import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl-next';
import type { MessageDescriptor } from 'react-intl-next';

import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import { LinkButton } from '@atlaskit/button/new';

import { useSessionData } from '@confluence/session-data';

const i18n = defineMessages({
	downloadMobileAppCTA: {
		id: 'experiment-home-onboarding-takeover-v2.download-mobile-app.cta',
		defaultMessage: 'Learn about the app',
		description:
			'This will be shown on a button embedded into the home screen as a part of onboarding. Clicking the button will open a new page where they can download the mobile app',
	},
	changeSiteThemeCTA: {
		id: 'experiment-home-onboarding-takeover-v2.change-site-theme.cta',
		defaultMessage: 'Add branding',
		description:
			'This will be shown on a button embedded into the home screen as a part of onboarding. Clicking the button will open a new adminhub page where they change some site color themes and logos',
	},
	addProfilePictureCTA: {
		id: 'experiment-home-onboarding-takeover-v2.add-profile-picture.cta',
		defaultMessage: 'Add photo',
		description:
			'This will be shown on a button embedded into the home screen as a part of onboarding. Clicking the button will open a new settings page where they can add a profile photo',
	},
});

type HTV2ActionCardLinkCTA = {
	onboardingAction: string;
	ctaText: MessageDescriptor;
	href: string;
};

const HTV2ActionCardLinkCTA = ({ onboardingAction, ctaText, href }: HTV2ActionCardLinkCTA) => {
	const { createAnalyticsEvent } = useAnalyticsEvents();

	const handleClick = () => {
		createAnalyticsEvent({
			type: 'sendUIEvent',
			data: {
				action: 'clicked',
				actionSubject: 'button',
				actionSubjectId: 'homeOnboardingTakeoverV2ActionCta',
				attributes: {
					onboardingAction,
				},
			},
		}).fire();
	};

	return (
		<LinkButton onClick={handleClick} href={href} target="_blank">
			<FormattedMessage {...ctaText} />
		</LinkButton>
	);
};

export const HTV2DownloadMobileAppCTA = () => {
	return (
		<HTV2ActionCardLinkCTA
			onboardingAction="downloadMobileApp"
			ctaText={i18n.downloadMobileAppCTA}
			href="https://www.atlassian.com/software/confluence/mobile-app"
		/>
	);
};

export const HTV2AddProfilePictureCTA = () => {
	const { userId } = useSessionData();
	return (
		<HTV2ActionCardLinkCTA
			onboardingAction="addProfilePicture"
			ctaText={i18n.addProfilePictureCTA}
			href={`/wiki/people/${userId}`}
		/>
	);
};

export const HTV2ChangeSiteThemeCTA = () => {
	return (
		<HTV2ActionCardLinkCTA
			onboardingAction="changeSiteTheme"
			ctaText={i18n.changeSiteThemeCTA}
			href="/wiki/admin/look-and-feel/customize-navigation"
		/>
	);
};
